import Verify from './Verify';
import create from './QuestionCreate';


export default{ 
    Verify, 
    create 
};
